import type { EntryPoint } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type PopupContent from './popup-content';

export const popupEntryPoint: EntryPoint<typeof PopupContent, {}> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_@atlassian/entry-points/ConstellationPopupContent" */ './popup-content'
			),
		{ moduleId: 'constellation-popup-entry-point' },
	),
	getPreloadProps: () => ({}),
});
